window.addEventListener('DOMContentLoaded', function() {
  const handleVariantChange = () => {
    const productTitle = document.querySelector('.product-info__title');
    const infoBox = document.querySelector('.product-info__info-box');

    const variantsMetafieldData = JSON.parse(document.querySelector('#variants-metafield-data').innerHTML);

    window.addEventListener('variant:change', function(e) {
      const currentVariantId = e.detail.variant.id;

      const currentVariantTitle = variantsMetafieldData.variantTitles.find(variant => variant.id === currentVariantId.toString()).title;
      const currentVariantInfoBox = variantsMetafieldData.variantInfoBoxes.find(variant => variant.id === currentVariantId.toString()).info;

      productTitle.textContent = currentVariantTitle;

      if (Boolean(currentVariantInfoBox)) {
        infoBox.innerHTML = currentVariantInfoBox;
        infoBox.classList.remove('hidden');
      } else {
        infoBox.classList.add('hidden');
      }
    })
  }

  handleVariantChange();
});
